import React, { useEffect, useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  CircularProgress
} from '@material-ui/core';
import { injectIntl, WrappedComponentProps } from 'react-intl';
import { useSnackbar } from 'notistack';
import {getPublicDoc} from '../../../crud/docs.crud';

interface IProps {
  isOpen: boolean;
  handleClose: () => void;
  contentType: string;
}

const TermDialog: React.FC<IProps & WrappedComponentProps> = ({
  isOpen,
  handleClose,
  contentType,
  intl,
}) => {
  const { enqueueSnackbar } = useSnackbar();

  const [content, setContent] = useState('');
  const [loading, setLoading] = useState(false);

  function getMessage(pathname: string) {
    switch (pathname) {
      case 'user_agreement':
        return 'SUBMENU.LEGAL_TERMS';
      case 'privacy_policy':
        return 'SUBMENU.LEGAL_PRIVACY';
      case 'shipping_policy':
        return 'SUBMENU.LEGAL_SHIPPING';
      case 'refund_policy':
        return 'SUBMENU.LEGAL_REFUND';
      default:
        return 'DOC.USER_AGREEMENT';
    }
  }

  useEffect(() => {
    setLoading(true);
    if (contentType !== '') {
      getPublicDoc(contentType)
        .then(res => {
          setContent(res.data.data.text);
          setLoading(false);
        })
        .catch((err: any) => {
          setLoading(false);
          enqueueSnackbar(err.message, {
            variant: 'error',
          });
        });
    }
  }, [contentType]);

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {intl.formatMessage({
          id: contentType ? getMessage(contentType) :'DOC.USER_AGREEMENT'
        })}
      </DialogTitle>
      <DialogContent
        style={{
          width: 450,
          height: 300,
          position: 'relative',
        }}
      >
        {loading ? (
          <div style={loaderWrapStyle}>
            <CircularProgress size={20}/>
          </div>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: content }} style={{color: 'black'}} />
        )}
      </DialogContent>
    </Dialog>
  );
};

const loaderWrapStyle = {
  height: '100%',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}

export default injectIntl(TermDialog);
